angular.module('mtic')
.constant('URL_VERSIONS', {
    Live: 'Live',       // for all users
    Prelive: 'Prelive', // for testing by SMEs
    Preview: 'Preview', // for most testing by the QC team. Connected to live database
  })
  